var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    class: _vm.classes,
    attrs: {
      "exact-active-class": _vm.exactActiveClass,
      "active-class": _vm.activeClass,
      "to": _vm.to
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b2a951f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/appComponents/components/RouterLink/RouterLink.vue
// module id = 686
// module chunks = 0